const convertToBinary = (data) => {
    return data === "Yes" ? "1" : "0"; // Converts "Yes" → "1", "No" → "0"
};

export const ClientCounterpartyApiFactory = (apiData = {}) => {
    return {
        entityId: apiData.entityId || "",
        clientType: apiData.clientType || "",
        // entityType: apiData.transactionType || "",
        registrationNumber: apiData.registrationNumber || "",
        description: apiData.description || "",
        sourceOfFunds: apiData.sourceOfFunds || "",
        headsOfTermDate: apiData.headsOfTermDate || "",
        anticipatedCompletionDate: apiData.anticipatedCompletionDate || "",
        entityName: apiData.entityName || "",
        CompanyName: apiData.companyName || "",
        countryOfIncorporation: apiData.countryOfIncorporation || "",
        CompanyType: apiData.companyType || "",
        EntitiesNumber: apiData.overseasEntitiesNumber || "",
        isRegulatoryListed: apiData.isRegulatoryListed ? convertToBinary(apiData.isRegulatoryListed) : "",
        OverseasEntities: apiData.overseasEntities ? convertToBinary(apiData.overseasEntities) : "",
        isBillingEntityListed: (apiData.isBillingRecognized || apiData.isBillingEntityListed) ? convertToBinary(apiData.isBillingRecognized || apiData.isBillingEntityListed) : "",
        landregistercopy: apiData.landRegisterCopy ? convertToBinary(apiData.landRegisterCopy) : "",
        relianceFromThirdParty: apiData.relianceFromThirdParty ?convertToBinary(apiData.relianceFromThirdParty) : "",
        compliantLetter: apiData.compliantLetter ? convertToBinary(apiData.compliantLetter) : "",
        complyWithRegulations: apiData.complyWithRegulations ? convertToBinary(apiData.complyWithRegulations) : "",
        regulatoryReferenceNumber: apiData.regulatoryReferenceNumber || "",
        regulatoryBody: apiData.regulatoryBody || "",
        transactionReference: apiData.transactionReference || "",
        ThirdPartyRelianceType: apiData.ThirdPartyRelianceType || "",
        entityType: apiData.entityType || "",
        entity_Status: apiData.status || "",
        AddressLine1: apiData.addressLine1 || "",
        AddressLine2: apiData.addressLine2 || "",
        AddressLine3: apiData.addressLine3 || "",
        state: apiData.state || "",
        City: apiData.city || "",
        RecognisedExchange: apiData.recognisedExchange || "",
        Postcode: apiData.postCode || "",
        ExistingProperty: apiData.existingProperty || "",
        // Persist diligence type onto Entity record so backend can drive
        // Corporate Structure / Management Data N/A handling under Simplified diligence.
        diligenceStatus: apiData.diligenceStatus ? apiData.diligenceStatus.toLowerCase() : "",
        regulatoryBodyAutorizedBy: apiData.regulatoryBodyAutorizedBy || "",
        otherRegulatoryBody: apiData.otherRegulatoryBody || "",
        otherRegulatedEntity: apiData.otherRegulatedEntity || "",
        ClientReferenceNumber: apiData.clientReferenceNumber || "",

    };
};
